// The personal data flag on a Theme AI task (#494, #488): where the junk
// check reports it, how the flagged answers are reviewed, what each choice
// does and what the download holds. It clicks nothing that starts, saves or
// downloads anything, and explains the review in words so it runs whether or
// not the task has been checked.

import type { Walkthrough } from './types'

export const themeAIPersonalData: Walkthrough = {
  slug: 'theme-ai-personal-data',
  title: 'Flag answers with personal data',
  summary: 'Opens a Theme AI task, moves to its Run step and shows where the junk check reports answers with personal data, then how they are reviewed, flagged and listed for data management. Nothing is started, saved or downloaded.',
  issue: '#494',
  added: '2026-10-27',
  skipE2E: 'needs a Theme AI task with a code frame on the fixture job',
  steps: [
    {
      page: 'theme-ai-tasks',
      feature: 'themeai/task-list',
      control: 'Open task',
      say: 'This is the list of Theme AI tasks. I will open one that already has a code frame.',
    },
    {
      page: 'theme-ai-tasks',
      feature: 'themeai/task-list',
      click: 'Open task',
      say: 'Opening the task.',
    },
    {
      route: 'theme-ai-task',
      feature: 'themeai/run',
      click: 'Run step',
      say: 'Its Run step, where coding starts. A task that has already run opens on Results, so I move to Run.',
    },
    {
      route: 'theme-ai-task',
      feature: 'themeai/personal-data-flag',
      control: 'Check',
      say: 'The junk check also looks for personal data: names, email addresses, phone numbers, postcodes and ID numbers. It is the same check and the same model reading, so it costs nothing extra.',
    },
    {
      route: 'theme-ai-task',
      feature: 'themeai/personal-data-flag',
      say: 'When a check finishes, the Run step says how many answers contain personal data, with Review personal data. The review lists each one with the kinds of data found and whether a rule or the model found it. Switch Keep on for any that are fine.',
    },
    {
      route: 'theme-ai-task',
      feature: 'themeai/personal-data-flag',
      say: 'Then choose: Do not flag them codes everything as usual. Flag them as “contains personal data” codes them as usual and adds code 98, so they can be found in Results and in tables. The answers themselves are never changed or removed.',
    },
    {
      route: 'theme-ai-task',
      feature: 'themeai/personal-data-flag',
      say: 'Download list (CSV) gives your data management team each flagged answer’s record id and case id with the kind of data found. It holds no answer text, so it can be passed on safely, and the data owner removes or changes the answers at source.',
    },
  ],
}
